import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, SaveButton, SystemText } from 'e4shared';
import Sorter from 'components/admin/forms/sorter';
import { apiPatch } from 'services';

export const SortPositiveIndicators = ({ show, close, refresh, data }) => {
    const user = useSelector(state => state.user.user);
    const [saving, setSaving] = React.useState(false);
    const [order, setOrder] = React.useState([]);

    const onSave = () => {
        const promises = [];

        order.forEach(x => {
            promises.push(apiPatch('positive-indicators', x, user.guid));
        });

        Promise.all(promises).then(() => {
            setTimeout(() => {
                refresh();
                close();
            }, 500);
        });
    };

    const footer = (
        <div className="pull-right">
            <SaveButton
                data-testid="button-save"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={() => onSave()}
            >
                {SystemText('Admin/PositiveIndicators/Sort/Buttons/Save')}
            </SaveButton>
            <button data-testid="button-close" className="btn" onClick={() => close()}>
                {SystemText('Admin/PositiveIndicators/Sort/Buttons/Close')}
            </button>
        </div>
    );

    return (
        <Modal title={SystemText('Admin/PositiveIndicators/Sort/Modal/Title')} show={show} close={close} footer={footer}>
            <Sorter
                label={SystemText('Admin/PositiveIndicators/Sort/Sorter/Label')}
                help={SystemText('Admin/PositiveIndicators/Sort/Sorter/Help')}
                options={data}
                onChange={options => setOrder(options)}
            />
        </Modal>
    );
};

export default SortPositiveIndicators;
